import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const FireReactionShape = ({
  width = 30,
  height = 30,
  fillColor = '#ffffff',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_340_1981)">
      <path
        d="M10 19.1667C8.74764 19.1666 7.52419 18.7902 6.48827 18.0864C5.45236 17.3826 4.65177 16.3839 4.19031 15.2196C3.72884 14.0554 3.62779 12.7793 3.90025 11.5569C4.17271 10.3346 4.80612 9.22223 5.71835 8.36417C6.83668 7.31167 9.58335 5.41667 9.16668 1.25C14.1667 4.58333 16.6667 7.91667 11.6667 12.9167C12.5 12.9167 13.75 12.9167 15.8334 10.8583C16.0584 11.5025 16.25 12.195 16.25 12.9167C16.25 14.5743 15.5915 16.164 14.4194 17.3361C13.2473 18.5082 11.6576 19.1667 10 19.1667Z"
        fill={fillColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_340_1981">
        <rect width="20" height="20" fill={fillColor} />
      </clipPath>
    </defs>
  </svg>
);

export default FireReactionShape;
